import AccessDenied from "components/AccessDenied/AccessDenied";
import AppRoutes from "AppRoutes";
import Loader from "components/Loader/Loader";
import { useAuth } from "context/AuthContext";
import { useEffect } from "react";

function AuthenticationWrapper() {
  const { isAuthenticated, isUnauthorized, loading, signIn } = useAuth();
  
  // If we're on the callback route, always show AppRoutes to let the callback handle authentication
  const isCallbackRoute = window.location.pathname === "/login/callback";

  // Auto-redirect to Okta if not authenticated and not in callback route
  useEffect(() => {
    if (!loading && !isAuthenticated && !isUnauthorized && !isCallbackRoute) {
      console.log("Redirecting to Okta login...");
      // Add a small delay to ensure auth state has been fully processed
      const timer = setTimeout(() => {
        void signIn?.();
      }, 100);
      
      return () => clearTimeout(timer);
    }
  }, [loading, isAuthenticated, isUnauthorized, isCallbackRoute, signIn]);
  
  if (loading) {
    return <Loader isFullScreen={true} text="Loading" />;
  }

  if (isUnauthorized) {
    return <AccessDenied />;
  }
  
  if (isCallbackRoute || isAuthenticated) {
    return <AppRoutes />;
  }
  
  // Show loading message while redirect is happening
  return <Loader isFullScreen={true} text="Redirecting to login" />;
  
}

export default AuthenticationWrapper;
